import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';

@Component({
	selector: 'app-marca-veiculo',
	templateUrl: './marca-veiculo.component.html',
	styleUrls: ['./marca-veiculo.component.css'],
	animations: [loadingFade, modal, alert]
})
export class MarcaVeiculoComponent implements OnInit {
	public loading = false;
	public marcasveiculo = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	//acesso
	public menu_id = 126; //Cadastro - ADM
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	

	constructor(private marcaVeiculoSvc: MarcaVeiculoService,		
		private route: ActivatedRoute,
		private perfilUsuarioSvc: PerfilUsuarioService,
		private authSvc: AuthService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.pegaMarcasVeiculo();
	}

	pegaMarcasVeiculo() {
		this.marcasveiculo = [];
		this.loading = true;
		this.marcaVeiculoSvc.getMarcasVeiculo().then((data: any[]) => {
			this.marcasveiculo = data;
			this.count = this.marcasveiculo.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaMarca(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.marcaVeiculoSvc.apagaMarcaVeiculo(id).then((data) => {
					this.pegaMarcasVeiculo();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	onChangeStatus(marca_veiculo_id, event){
		this.loading = true;
		let status = event.srcElement.checked == true ? '1' : '0';
		let toSend = ({
		  'marca_veiculo_id': marca_veiculo_id,
		  'status': status,
		});


		this.marcaVeiculoSvc.editaMarcaVeiculoStatus(toSend).then((data) => {
		  this.loading = false;
		  Swal.fire({
			type: 'success',
			title: 'Status alterado com sucesso!'
		  });
		}).catch(err => {
		  console.log(err);
		  this.loading = false;
		  Swal.fire({
			type: 'error',
			title: 'Ops! Algo de errado aconteceu!',
			text: 'Tente novamente mais tarde.'
		  });
		});
	}


}
